export function login(action = 'login') {
  if (window._miniLogin_) {
    window._miniLogin_.showComponent({
      show_type: action
    })   // 显示登录组件
  }
}
